import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableProps } from '../../types';
import { CellCenterWrapper } from '../../styles';
import { Button } from '../../../../../../../../../components';
import { URLS_LIST } from '../../../enums';

export const Delete = ({
  val, row, setOpenModal, setModalInfo, isReadOnly,
}: TableProps) => (
  <CellCenterWrapper>
    <Button
      onClick={() => {
        setOpenModal();
        setModalInfo({
          id: row.id,
          manualUrl: row.url,
          type: URLS_LIST.MODAL.TYPES.REMOVE,
        });
      }}
      theme="quaternary"
      disabled={isReadOnly}
    >
      <FontAwesomeIcon icon={val} />
    </Button>
  </CellCenterWrapper>
);
